import {Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {LoginService} from '../../services/login.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
  styleUrls: ['./two-step-dialog.component.scss'],
  templateUrl: './two-step-dialog.component.html'
})
export class TwoStepDialogComponent {
  public authNumber: any;
  private readonly userId: number;
  @ViewChild('n1', {static: false}) number1: ElementRef;
  @ViewChild('n2', {static: false}) number2: ElementRef;
  @ViewChild('n3', {static: false}) number3: ElementRef;
  @ViewChild('n4', {static: false}) number4: ElementRef;
  @ViewChild('n5', {static: false}) number5: ElementRef;
  @ViewChild('n6', {static: false}) number6: ElementRef;


  constructor(private loginService: LoginService,
              private matDialogRef: MatDialogRef<TwoStepDialogComponent>,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.userId = this.data.userId;

    this.authNumber = {
      num1: null,
      num2: null,
      num3: null,
      num4: null,
      num5: null,
      num6: null,
    };
  }

  filledNumbers(): boolean {
    return this.authNumber.num1 === null || this.authNumber.num2 === null ||
      this.authNumber.num3 === null || this.authNumber.num4 === null || this.authNumber.num5 === null || this.authNumber.num6 === null;
  }

  areNumbersFilled(): boolean {
    return this.authNumber.num1 !== null && this.authNumber.num2 !== null &&
      this.authNumber.num3 !== null && this.authNumber.num4 !== null && this.authNumber.num5 !== null && this.authNumber.num6 !== null;
  }

  async checkCode() {
    try {
      const result = await this.loginService.checkCode(this.authNumber, this.userId);
      this.matDialogRef.close(result);
    } catch (e) {
      this.toastMessagesService.toastMessages('Ο αριθμός που πληκτρολογήσατε δεν είναι σωστός');
      this.clearNumbers();
    }
  }

  clearNumbers() {
    this.authNumber.num1 = null;
    this.authNumber.num2 = null;
    this.authNumber.num3 = null;
    this.authNumber.num4 = null;
    this.authNumber.num5 = null;
    this.authNumber.num6 = null;
  }

  async keyFocus($event: any, index: number) {
    if (this.areNumbersFilled()) {
      await this.checkCode();
      return;
    }

    let element;
    switch (index) {
      case 1:
        element = this.number2.nativeElement;
        break;
      case 2:
        element = this.number3.nativeElement;
        break;
      case 3:
        element = this.number4.nativeElement;
        break;
      case 4:
        element = this.number5.nativeElement;
        break;
      case 5:
        element = this.number6.nativeElement;
        break;
    }

    setTimeout(() => {
      if (index !== 6) {
        element.focus();
      }
    });
  }
}
